(() => {
  const init = (root) => {
    const buttons = root.querySelectorAll('[data-city]');
    const panels = root.querySelectorAll('[data-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const city = button.getAttribute('data-city');
        buttons.forEach((item) => item.classList.toggle('is-active', item === button));
        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-panel') === city);
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-nada-distribution]').forEach(init);
  });
})();
